import React from 'react';
interface LeftArrowProps {
  className?: string;
}
export const LeftArrow = (props: LeftArrowProps) => {
  return (
    <svg
      className={props.className}
      width="27"
      height="77"
      viewBox="0 0 27 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M22.129 76C0.332857 59.0187 -6.10615 42.1283 9.95338 13.9049C16.4918 2.41418 35.4842 23.6863 20.1873 3.75638C19.0863 2.32192 16.8504 0.261051 15.34 1.26664C14.009 2.15278 17.6394 3.84997 17.6629 5.43705C17.7541 11.598 13.1722 18.1743 15.6738 23.817C17.2074 27.2762 19.5453 17.3054 21.4811 14.0495"
        stroke="#727476"
      />
    </svg>
  );
};
